<template>
  <div class="solution-detail-component">
    <!-- 行业需求部分 -->
    <div class="bjt">
      <img src="../../../public/img/internet/暖通.png" alt="" />
    </div>

    <!-- 解决方案部分 -->
    <section class="solutions">
      <h2 class="section-title">解决方案</h2>
      <div class="solutions-list">
        <div class="solution-item">
          <div class="icon-placeholder">
            <img
              class="fanganimg"
              src="../../../public/img/internet/solution/icon1-5.png"
              alt=""
            />
          </div>
          <div class="solution-content">
            <h3>工业级4G DTU</h3>
            <p>定制开发了专用的防水防尘4G DTU</p>
          </div>
        </div>
        <div class="solution-item">
          <div class="icon-placeholder">
            <img
              class="fanganimg"
              src="../../../public/img/internet/solution/icon1-6.png"
              alt=""
            />
          </div>
          <div class="solution-content">
            <h3>定制研发平台</h3>
            <p>
              依托暖通运营管理平台，创新大数据和人工智能应用技术，智能调节机组运行参数，提高运维效率和用能效率
            </p>
          </div>
        </div>
        <div class="solution-item">
          <div class="icon-placeholder">
            <img
              class="fanganimg"
              src="../../../public/img/internet/solution/icon1-7.png"
              alt=""
            />
          </div>
          <div class="solution-content">
            <h3>实时监控</h3>
            <p>实时监控设备运行状态，降低故障风险</p>
          </div>
        </div>
        <div class="solution-item">
          <div class="icon-placeholder">
            <img
              class="fanganimg"
              src="../../../public/img/internet/solution/icon1-8.png"
              alt=""
            />
          </div>
          <div class="solution-content">
            <h3>流程化设计</h3>
            <p>
              流程化设计，减少相关环节管理漏洞和降低维护人员技术门槛，弥补人为因素的限制，避免能源浪费
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务成效部分 -->
    <section class="service-results">
      <h2 class="section-title">服务成效</h2>
      <div class="results-list">
        <div class="result-item">
          <div class="icon-placeholder">
            <img
              class="fanganimgss"
              src="../../../public/img/internet/solution/icon1-9.png"
              alt=""
            />
          </div>
          <h3>高稳定性</h3>
          <p>
            提供高稳定性的防水防尘模组硬件，降低80%因灰尘、氧化、湿度、盐度等环境因素导致的故障率
          </p>
        </div>
        <div class="result-item">
          <div class="icon-placeholder">
            <img
              class="fanganimgss"
              src="../../../public/img/internet/solution/icon1-10.png"
              alt=""
            />
          </div>
          <h3>运维管理</h3>
          <p>
            提供物联网卡管理平台、设备管理平台及稳定、高效、及时的运维服务，做到量化知情，提高用能效率
          </p>
        </div>
        <div class="result-item">
          <div class="icon-placeholder">
            <img
              class="fanganimgss"
              src="../../../public/img/internet/solution/icon1-11.png"
              alt=""
            />
          </div>
          <h3>降低成本</h3>
          <p>操作简单，降低维护人员技术门槛，降低人力成本</p>
        </div>
        <div class="result-item">
          <div class="icon-placeholder">
            <img
              class="fanganimgss"
              src="../../../public/img/internet/solution/icon1-12.png"
              alt=""
            />
          </div>
          <h3>节能环保</h3>
          <p>节能环保，降低终端用户用电成本</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HvacSolution",
  emits: ["close"],
};
</script>

<style lang="scss" scoped>
.bjt {
  // position: relative;
  min-height: 382px;
  img {
    width: 1920px;
    height: 416px;
    position: absolute;
    top: 650px;
    left: 0;
    // object-fit: cover;
  }
}
.spansize {
  color: blue;
}
.solution-detail-component {
  padding: 40px;
  min-width: 1400px;
  margin: 0 auto;
}

.section-title {
  font-size: 40px;
  color: #333;
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  font-family: PingFang SC, PingFang SC-500;
  font-weight: 600;
  

 
  &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      margin: 10px auto 0;
    }
}

.industry-demands {
  margin-bottom: 60px;
  background: #fafafa;

  .section-title {
    font-size: 40px;
    color: #333;
    text-align: center;
    margin-bottom: 40px;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 600;


    &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      margin: 10px auto 0;
    }
  }
}

.demands-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  text-align: left;
}

.demand-item {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
 
  position: relative;

  .demand-label {
    font-size: 14px;
    color: #9e9191;
    margin-bottom: 8px;
  }

  h3 {
    font-size: 20px;
    color: #333;
    margin-bottom: 16px;
    font-weight: 500;
  }

  p {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin: 0;
  }

  .icon-placeholder {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 32px;
    height: 32px;
    // background-color: #e6f7ff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

// 解决方案样式
.solutions-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 60px;
}

.solution-item {
  display: flex;
  align-items: center;
  padding: 30px;
  background: #fafafa;
  border-radius: 12px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f3f6ff;
    border-color: #1890ff;
    .icon-placeholder {
      // background-color: #fff;
    }
    h3 {
      color: #1890ff;
    }
  }

  .icon-placeholder {
    width: 80px;
    height: 80px;
    // background-color: #e6f7ff;
    border-radius: 12px;
    margin-right: 20px;
    flex-shrink: 0;
  }

  .solution-content {
    h3 {
      font-size: 18px;
      color: #333;
      margin-bottom: 10px;
      font-weight: 600;
      font-family: PingFang SC, PingFang SC-500;
    }

    p {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
    }
  }
}

// 服务成效样式
.service-results {
  margin-bottom: 60px;
  margin-top: 120px;
  .section-title {
    font-size: 40px;
    color: #333;
    text-align: center;
    margin-bottom: 40px;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 600;

    &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      margin: 10px auto 0;
    }
  }
}

.results-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.result-item {
  text-align: center;
  padding: 32px 24px;
  background: #ffffff;
  border-radius: 12px;
  //  
  transition: all 0.3s ease;
  border: 2px solid transparent;
  border: 2px solid #e5e7eb;

  &:hover {
    /* 移除浮动和阴影效果 */
    /* transform: translateY(-5px); */
    /* box-shadow: 0 12px 24px rgba(24, 144, 255, 0.12); */
    border-color: #1890ff;
    .icon-placeholder {
      // background-color: #E6F7FF;
    }
    h3 {
      color: #1890ff;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 600;
    }
  }

  .icon-placeholder {
    width: 100px;
    height: 100px;
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  h3 {
    font-size: 20px;
    color: #333333;
    margin-bottom: 16px;
    font-weight: 500;
    transition: color 0.3s ease;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    color: #666666;
    line-height: 1.6;
    margin: 0;
    padding: 0 12px;
  }
}

.fanganimgss {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.icon-placeholders {
  width: 45px;
  height: 45px;
}

.fanganimg {
  width: 83px;
  height: 83px;
}
.solutions {
  margin-top: -40px;  
  margin-bottom: 60px;
  .solutions-list {
    text-align: left;
    // font-weight: 600;
  }
}
</style>
